<template>
	<div class="sidebar-container">
		<div class="scrollbar-wrapper">
			<ul class="sideBar-menu-ul">
				<div v-for="(item,index) in menuList" :key="index">
					<div class="m-header">{{item.title}}</div>
					<li class="sideBar-menu-item " :class="menuUrl == jtem.url ? 'sideBar-menu-active-item' : ''"
						v-for="(jtem,jndex) in item.sub" :key="jndex" @click="chengeMenu(jtem.url)">
						<div class="active-t" v-if="menuUrl == jtem.url"></div>
						<img :src="jtem.icon" class="menu-icon" />
						<div class="menu-txt">{{jtem.title}}</div>
						<span class="unread" v-if="jtem.num > 0"></span>
					</li>
				</div>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			menuUrl: {
				type: String,
				default: '/',
			}
		},
		data() {
			return {
				menuIndex: 0,
				cachedCqty: parseInt(localStorage.getItem('cqty') || '0'),
				addOrderqty: parseInt(localStorage.getItem('addOrderqty') || '0'),
				menuList: [{
						title: this.$t('menu.dashboard'),
						sub: [{
							id: 1,
							icon: require('@/assets/images/menu/index.png'),
							title: this.$t('menu.dashboard'),
							num: 0,
							url: '/'
						}]
					},
					{
						title: this.$t('menu.product'),
						sub: [{
								id: 2,
								icon: require('@/assets/images/menu/product.png'),
								title: this.$t('menu.product'),
								num: 0,
								url: 'product',
							},
							{
								id: 5,
								icon: require('@/assets/images/menu/kh.png'),
								title: this.$t('menu.productReview'),
								num: 0,
								url: 'review'
							}
						]
					},
					{
						title: this.$t('menu.order'),
						sub: [{
								id: 6,
								icon: require('@/assets/images/menu/order.png'),
								title: this.$t('menu.orderlist'),
								num: 0,
								url: 'order-lists'
							},
							{
								id: 7,
								icon: require('@/assets/images/menu/tk.png'),
								title: this.$t('menu.shoplevle'),
								num: 0,
								url: 'level'
							},
							{
								id: 15,
								icon: require('@/assets/images/menu/return.png'),
								title: this.$t('menu.spreadpackages'),
								num: 0,
								url: 'package'
								// },
								// {
								// 	id: 8,
								// 	icon: require('@/assets/images/menu/fx.png'),
								// 	title: 'Purchase Spread Package',
								// 	num: 0,
								// 	url: 'purchase'
							}
						]
					},
					 {
					 	title: this.$t('live.live'),
					  	sub: [{
					  			id: 19,
					  			icon: require('@/assets/images/menu/live.png'),
					  			title: this.$t('live.live'),
					  			num: 0,
					  			url: 'live-lists'
					  		}
					  	]
					  },
					{
						title: this.$t('menu.finance'),
						sub: [
							/*{
															id: 9,
															icon: require('@/assets/images/menu/pay.png'),
															title: this.$t('menu.paymenthistory'),
															num: 0,
															url: "payLog"
														},*/
							{
								id: 10,
								icon: require('@/assets/images/menu/yj.png'),
								title: this.$t('menu.mywallet'),
								num: 0,
								url: 'wallet'
							},
							{
								id: 11,
								icon: require('@/assets/images/menu/message.png'),
								title: this.$t('menu.conversations'),
								num: 0, // 初始值设为0  // 绑定 cqty 参数
								url: 'conversations'
							},
							{
								id: 13,
								icon: require('@/assets/images/menu/xyf.png'),
								title: this.$t('menu.refundrequest'),
								num: 0,
								url: 'refund'
							},
							{
								id: 17,
								icon: require('@/assets/images/menu/ly.png'),
								title: this.$t('menu.payment'),
								num: 0,
								url: 'payment'
							}
						]
					},
					{
						title: this.$t('menu.alliancesystem'),
						sub: [

							{
								id: 18,
								icon: require('@/assets/images/menu/alliance.png'),
								title: this.$t('menu.alliancecenter'),
								num: 0,
								url: 'alliance'
							},
						]
					},
					{
						title: this.$t('menu.setting'),
						sub: [

							{
								id: 16,
								icon: require('@/assets/images/menu/tj.png'),
								title: this.$t('menu.shopsetting'),
								num: 0,
								url: 'setting'
							},
							{
								id: 14,
								icon: require('@/assets/images/menu/set.png'),
								title: this.$t('menu.transactionpassword'),
								num: 0,
								url: 'password'
							}
						]
					}
				],
				// menuUrl:'homeIndex'
			};
		},
		created() {},
		beforeDestroy() {
			// 移除事件监听
		},
		mounted() {
			// 初始化时更新一次菜单数值
			this.updateConversationMenuNum();
			this.updateConversationMenuNum6();
		},
		methods: {
			handleBrage() {
				this.cachedCqty = parseInt(localStorage.getItem('cqty') || '0')
				this.addOrderqty = parseInt(localStorage.getItem('addOrderqty') || '0')
				this.updateConversationMenuNum();
				this.updateConversationMenuNum6();
			},
			handleStorageChange(e) {
				if (e.key === 'cqty') {
					this.cachedCqty = parseInt(e.newValue) || 0;
					this.updateConversationMenuNum();
				} else if (e.key === 'addOrderqty') {
					this.addOrderqty = parseInt(e.newValue) || 0;
					this.updateConversationMenuNum6();
				}
			},
			updateConversationMenuNum() {
				// 找到 Conversations 菜单项并更新 num 值
				const financeMenu = this.menuList.find(menu => menu.title === 'Finance');
        console.log(financeMenu)
				if (financeMenu) {
					const conversationItem = financeMenu.sub.find(item => item.id === 11);
					if (conversationItem) {
						conversationItem.num = this.cachedCqty;
					}
				}
			},
			updateConversationMenuNum6() {
				// 找到 Conversations 菜单项并更新 num 值
				const financeMenu = this.menuList.find(menu => menu.title === 'Order');
				if (financeMenu) {
					const conversationItem = financeMenu.sub.find(item => item.id === 6);
					if (conversationItem) {
						conversationItem.num =  this.addOrderqty;
					}
				}
			},
			chengeMenu(e) {
				// 可以在这里添加额外的逻辑
				if (e == 'order-lists') {
					localStorage.setItem('addOrderqty', 0);
				}
				this.openPage(e)
			}
		}
	};
</script>

<style scoped>
	::-webkit-scrollbar {
		display: none;
	}

	::-webkit-scrollbar-thumb {
		display: none;
	}

	.sidebar-container {
		transition: width 0.28s;
		width: 237px;
		background-color: #fff;
		height: 100%;
	}

	.scrollbar-wrapper {
		width: 237px;
		height: 100%;
		position: relative;
		top: 0;
		bottom: 0;
		left: 0;
	}

	.sideBar-menu-ul {
		border: none;
		height: 100%;
		width: 100%;
		list-style: none;
		position: relative;
		padding: 0 !important;
		overflow: scroll;
		margin: 0;

	}

	.m-header {
		width: 100%;
		height: 40px;
		line-height: 40px;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		font-size: 13px;
		color: gray;
		text-indent: 20px;
	}

	.sideBar-menu-item {
		width: 100%;
		height: 40px;
		line-height: 40px;
		position: relative;
		cursor: pointer;
		overflow: hidden;
		display: flex;
		align-items: center;
		list-style: none;
		margin: 0;
	}

	.sideBar-menu-item:hover {
		background-color: #ECF3FF;
	}

	.sideBar-menu-item .active-t {
		position: absolute;
		width: 3px;
		height: 20px;
		top: 8px;
		left: 0;
		background-color: #443FF6;
	}

	.sideBar-menu-item .menu-icon {
		float: left;
		width: 20px;
		height: 20px;
		margin: 0 10px 0 20px;
	}

	.sideBar-menu-item .menu-txt {
		float: left;
		max-width: calc(100% - 70px);
		height: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		font-size: 13px;
	}

	.sideBar-menu-active-item {
		background-color: #ECF3FF;
	}

	.sideBar-menu-active-item .menu-txt {
		color: #443FF6;
	}

	.sideBar-menu-item .unread {
		width: 6px;
		height: 6px;
		background-color: red;
		border-radius: 50px;
		text-align: center;
		margin-top: -8px;
		margin-left: 3px;
	}

	.set-menu-block {
		height: 40px;
		line-height: 40px;
		width: 100%;
		position: absolute;
		bottom: 0;
		left: 0;
		overflow: hidden;
		display: flex;
		align-items: center;
		cursor: pointer;
		z-index: 20;
		background-color: #fff;
	}

	.set-menu-block .active-t {
		position: absolute;
		width: 3px;
		height: 20px;
		top: 10px;
		left: 0;
		background-color: #443FF6;
	}

	.set-menu-active-item {
		background-color: #ECF3FF;
	}

	.set-menu-active-item .set-menu-txt {
		color: #443FF6;
	}

	.set-menu-icon {
		float: left;
		width: 20px;
		height: 20px;
		margin: 0 10px 0 30px;
	}

	.set-menu-txt {
		float: left;
		width: calc(100% - 105px);
		height: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
		font-size: 13px;
	}

	@media (max-width: 767px) {
		.sidebar-container {
			display: none;
		}
	}
</style>
